<template>
  <div>
    <template v-if="exportType === 'button'">
      <el-button
        :size="formSize"
        @click="hancleExportReport"
        :loading="isExportLoading"
        v-track
        :trackCode="trackCode"
        :type="buttonType"
        v-bind="$attrs"
        :class="buttonClass"
      >
        {{buttonText}}
      </el-button>
    </template>
    <template v-else>
      <el-button
        type="primary"
        :size="formSize"
        @click="handleExport"
        :loading="isExportLoading"
        :disabled="total > limit || buttonLoadingText !== buttonText"
        v-track
        :trackCode="trackCode"
      >
        {{buttonLoadingText}}
      </el-button>
      <template v-if="total > limit">
        <el-tooltip class="item" effect="dark" content="最多只能导出20W，导出支持按筛选条件导出。若需导出超过20W以上数据，请联系开发人员" placement="top-start">
          <i class="el-icon-question"></i>
        </el-tooltip>
      </template>
    </template>

    <!-- 导出报表 -->
    <export-report-dialog
      :title="title"
      :visible.sync="isExportShow"
      :loading.sync="isExportLoading"
      @export-report="hancleExportReport"
      v-bind="$attrs"
      v-on="$listeners"
    >
      <div slot="main" slot-scope="{data}">
        <slot name="main" :data="data" />
      </div>
    </export-report-dialog>
  </div>
</template>

<script>
import exportReportDialog from './dialog';
import { getAccount } from '@/utils/account';
import { dataExport } from '@/api/global';

export default {
  name: 'pageExportButton',
  components: { exportReportDialog },
  props: {
    // 标题
    title: {
      type: String,
    },
    // 导出的类型
    exportServe: {
      type: String,
    },
    // 导出参数
    exportParams: {
      type: Object,
    },
    // 自定义时间参数
    timeParamProps: {
      type: Object,
      default: () => ({
        beginTime: 'beginTime',
        endTime: 'endTime',
      }),
    },
    // 导出类型
    exportType: {
      type: String,
      default: 'default',
    },
    // 按钮文案
    buttonText: {
      type: String,
      default: '报表导出',
    },
    // 是否有数量限制
    isLimit: {
      type: Boolean,
      default: false,
    },
    // 限制的数量
    limit: {
      type: Number,
      default: 200000,
    },
    // 数据总数
    total: {
      type: Number,
      default: 0,
    },
    // 自定义校验
    checkFun: {
      type: Function,
    },
    buttonType: {
      type: String,
      default: 'primary',
    },
    trackCode: {
      type: [String, Number],
    },
    buttonClass: {
      type: [Array, Object, String],
    },
  },
  data() {
    return {
      isExportShow: false,
      isExportLoading: false,
      buttonLoadingText: this.buttonText,
      currentReportId: '', // 当前报表ID
      pageTimer: {}, // 计时器数组
    };
  },
  mounted() {
    this.resetInterval();
  },
  beforeDestroy() {
    this.resetInterval();
  },
  methods: {
    resetInterval() {
      this.$store.dispatch('global/resetDownloadInterval');
    },
    // 导出报表弹窗
    handleExport() {
      const { downloadPageTimer = {} } = this.$store.state.global;
      // 避免产生太多定时器，导致浏览器卡死
      if (Object.keys(downloadPageTimer).length === 10) {
        this.$message.warning('当前操作过于频繁，请稍后再试！');
        return;
      }
      if (this.isLimit) {
        this.$confirm('是否确认导出？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(() => {
          this.hancleExport(this.exportParams);
        });
        return;
      }
      this.isExportShow = true;
    },
    hancleExportReport(param = {}, isCustom = false) {
      if (isCustom) {
        this.hancleExport(this.exportParams);
        return;
      }
      const params = {
        [this.timeParamProps.beginTime]: param.beginTime,
        [this.timeParamProps.endTime]: param.endTime,
        ...this.exportParams,
      };
      this.hancleExport(params);
    },
    async hancleExport(params = {}) {
      let flag = true;
      if (this.checkFun && typeof this.checkFun === 'function') {
        flag = this.checkFun();
      }
      if (flag) {
        this.buttonLoadingText = '正在导出...';
        this.isExportShow = false;
        try {
          this.isExportLoading = true;
          const account = getAccount();
          const res = await dataExport({
            sysType: 'FIN_SERVICE', // 系统类型
            templateCode: this.exportServe, // 表报主键，唯一
            reqParam: {
              currentUserId: account ? account.id : '',
              operator: account ? account.userName : '',
              ...params,
            }, // 导出参数
          }, this.exportServe);
          this.isExportShow = false;
          this.buttonLoadingText = this.buttonText;
          this.currentReportId = res.data?.taskId || '';
          if (res.data?.taskId) {
            this.$store.dispatch('global/getFileDownload', {
              taskId: res.data?.taskId,
              templateCode: this.exportServe,
            });
          }
          this.$emit('close');
          this.$store.commit('global/SET_DOWNLOAD_TEXT', '下载中');
          this.$store.commit('global/SET_DOWNLOAD_FLAG', true);
        } catch (error) {
          console.log(error);
        } finally {
          this.isExportShow = false;
          this.isExportLoading = false;
          this.buttonLoadingText = this.buttonText;
        }
      }
    },
  },
};
</script>
